import store from '../store'

import { getLocalStorage } from './storage'
import { getParameterFromPath, updateRouteParams } from './url'

import { setSelectedPlatform } from '../modules/actions/app'
import { SELECTED_PLATFORM } from '../modules/reducers/app'

import { ROUTE_PARAMS } from '../constants/routes'
import platformList, { FACEBOOK_PLATFORM, PLATFORMS_TO_PROVIDER } from '../constants/selectLists/platformList'

export const getSelectedPlatform = () => getParameterFromPath(ROUTE_PARAMS.platform)

export function getAvailablePlatformList(availableProviders = []) {
  // find available platforms from list of available providers
  return platformList.filter(({ value }) => {
    const platformProvider = PLATFORMS_TO_PROVIDER[value]
    return availableProviders.find(provider => provider === platformProvider)
  })
}

export function selectValidPlatform(availablePlatformList) {
  const { app } = store.getState()
  const currentPlatform = app.selectedPlatform

  const isPlatformValid = !!availablePlatformList.find(({ value }) => value === currentPlatform)

  if (!isPlatformValid) {
    // select new platform if current wasn't valid for selected partnership
    store.dispatch(setSelectedPlatform(availablePlatformList[0]?.value))
  }
}

export function getInitialPlatform() {
  const platformFromPath = getParameterFromPath(ROUTE_PARAMS.platform)
  const isPlatformValid = !!platformList.find(({ value }) => value === platformFromPath)
  const initialSelectedPlatform = getLocalStorage(SELECTED_PLATFORM) || FACEBOOK_PLATFORM

  if (!platformFromPath) {
    // not platform related path
    return initialSelectedPlatform
  }
  if (isPlatformValid) {
    // path with correct platform
    return platformFromPath
  } else {
    // path with not correct platform parameter - redirect to correct
    updateRouteParams({
      [ROUTE_PARAMS.platform]: initialSelectedPlatform
    })
    return initialSelectedPlatform
  }
}
